{
    "loginForm": {
        "forgotPassword": "Passwort vergessen?",
        "signIn": "Anmelden",
        "register": "Registrieren",
        "dontHaveAccount": "Don’t have an account?",
        "guestCheckout": "Guest Checkout",
        "emailAddress": {
            "label": "Nutzerkennung *",
            "placeholder": "Nutzerkennung"
        },
        "password": {
            "label": "Passwort *",
            "placeholder": "Passwort"
        },
        "wrongEmailFormat": "This is not a valid email format."
    },
    "miniLogin": {
        "userGreeting": "{{name}}",
        "signInRegister": "Anmelden"
    }
}